console.log("Custom popup ready");

document.addEventListener('DOMContentLoaded', function () {

  /* ================================
     POPUP
  ================================= */

  const popup = document.getElementById('professional-popup');
  const closeButton = document.getElementById('professional-popup-close');
  const overlay = document.querySelector('.professional-popup-overlay');
  const popupDismissedAtKey = 'sign24-professional-popup-dismissed-at-v2';
  const popupDismissalDuration = 60 * 60 * 1000;
  

  const getDismissedAt = function () {
    try {
      return Number(window.localStorage.getItem(popupDismissedAtKey)) || 0;
    } catch (error) {
      return 0;
    }
  };

  const setDismissedAt = function () {   
    try {
      window.localStorage.setItem(popupDismissedAtKey, String(Date.now()));
    } catch (error) {
      console.warn('No se pudo guardar el estado del popup:', error);
    }
  };

  const clearDismissedAt = function () {
    try {
      window.localStorage.removeItem(popupDismissedAtKey);
    } catch (error) {
      console.warn('No se pudo limpiar el estado del popup:', error);
    }
  };

  const removeTradeAccountBar = function () {
    const bar = document.getElementById('trade-account-announcement');

    if (bar) {
      bar.remove();
    }
  };

  const openPopup = function () {
    removeTradeAccountBar();
    popup.classList.add('professional-popup--ready');
    popup.classList.remove('hide');
  };

  const schedulePopupReopen = function (remainingTime) {
    window.setTimeout(function () {
      clearDismissedAt();
      openPopup();
    }, remainingTime);
  };

  const showTradeAccountBar = function () {
    if (document.getElementById('trade-account-announcement')) {
      return;
    }

    const header = document.querySelector('section[data-section-type="header"]');
    const bar = document.createElement('div');
    const link = document.createElement('a');

    bar.id = 'trade-account-announcement';
    bar.className = 'trade-account-announcement';
    link.href = 'https://sign24h.com/en/account/register';
    link.textContent = popup.dataset.tradeAccountAnnouncement || 'Complete your registration';
    link.addEventListener('click', function (event) {
      event.preventDefault();
      openPopup();
    });

    bar.appendChild(link);

    if (header) {
      header.before(bar);
    } else {
      document.body.prepend(bar);
    }
  };

  const closePopupManually = function () {
    popup.classList.add('hide');   
    setDismissedAt();
    showTradeAccountBar();
    schedulePopupReopen(popupDismissalDuration);
  };

  if (popup) {

    console.log("test-1")

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closePopupManually();        
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        closePopupManually();
      });
    }

    const dismissedAt = getDismissedAt();
    const remainingTime = popupDismissalDuration - (Date.now() - dismissedAt);

    if (dismissedAt && remainingTime > 0) {
      popup.classList.add('hide');
      showTradeAccountBar();
      schedulePopupReopen(remainingTime);
    } else if (dismissedAt) {
      clearDismissedAt();
    }

    popup.classList.add('professional-popup--ready');
  }

  /* ================================
     LOAD STATES
  ================================= */

  loadStates2();


  const country = document.getElementById('reg-contry');

  if (country) {
    country.addEventListener('change', function () {
      loadStates2();
    });
  }


  /* ================================
     REGISTER FORM
  ================================= */

  const form = document.getElementById('new-form-register');

  if (!form) {
    console.log('No se encontró #new-form-register');
    return;
  }

  const messages = document.getElementById('popup-form-messages');
  let activeSubmitButton;
  let clearMessagesTimer;

  const clearMessages = function () {
    window.clearTimeout(clearMessagesTimer);
    messages.replaceChildren();
  };

  const clearApiErrorsAfterDelay = function () {
    clearMessagesTimer = window.setTimeout(function () {
      messages.replaceChildren();
    }, 5000);
  };

  const setSubmitLoading = function (isLoading) {
    if (!activeSubmitButton) {
      return;
    }

    activeSubmitButton.disabled = isLoading;
    activeSubmitButton.classList.toggle('loading', isLoading);
  };

  const showMessage = function (type, title, errors) {
    clearMessages();

    const message = document.createElement('div');
    message.className = `octocode-messages octocode-${type}`;

    if (type !== 'errors' || errors.length === 0) {
      const heading = document.createElement('p');
      heading.textContent = title;
      message.appendChild(heading);
    }

    errors.forEach(function (error) {
      const row = document.createElement('div');
      row.textContent = error;
      message.appendChild(row);
    });

    messages.appendChild(message);
  };

  const showProfessionalMessage = function (type, text, detail) {
    clearMessages();

    const message = document.createElement('div');
    message.className = `popup-professional-message popup-professional-message--${type}`;

    const mainText = document.createElement('p');
    mainText.textContent = text;
    message.appendChild(mainText);

    if (detail) {
      const detailText = document.createElement('p');
      detailText.textContent = detail;
      message.appendChild(detailText);
    }

    messages.appendChild(message);
  };

  const showResultAndReload = function () {
    const formHeader = document.getElementById('validate-form');

    popup.classList.add('professional-popup--result');
    form.classList.add('popup-form--result');

    if (formHeader) {
      formHeader.classList.add('hide');
    }

    window.setTimeout(function () {
      form.reset();
      popup.remove();
      window.location.reload();
    }, 3000);
  };

  const getApiErrors = function (data) {
    const labels = {
      phone: messages.dataset.phoneLabel,
      'addresses.province': messages.dataset.provinceLabel,
      email: messages.dataset.emailLabel,
      cif: messages.dataset.cifLabel,
      eu_vat_id: messages.dataset.euVatIdLabel
    };

    const apiErrors = data && (data.errors || data.data);

    if (!apiErrors || typeof apiErrors !== 'object') {
      return [];
    }

    const errors = [];

    const collectErrors = function (value, field) {
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          collectErrors(item, field);
        });
        return;
      }

      if (value && typeof value === 'object') {
        Object.keys(value).forEach(function (key) {
          collectErrors(value[key], key);
        });
        return;
      }

      const label = labels[field];
      errors.push(label ? `${label}: ${value}` : value);
    };

    Object.keys(apiErrors).forEach(function (field) {
      collectErrors(apiErrors[field], field);
    });

    return errors;
  };

  const getMissingRequiredFields = function () {
    const requiredFields = form.querySelectorAll('[presence]');
    const missingLabels = [];

    requiredFields.forEach(function (field) {
      if (field.disabled || field.value.trim()) {
        return;
      }

      const labelEl = form.querySelector(`label[for="${field.id}"] .label-content`);
      missingLabels.push(labelEl ? labelEl.textContent.trim() : field.name);
    });

    return missingLabels;
  };

  form.addEventListener('submit', async function (event) {

    event.preventDefault();
    clearMessages();

    /* =================================
       VALIDAR CAMPOS REQUERIDOS
    ================================= */

    const missingLabels = getMissingRequiredFields();

    if (missingLabels.length > 0) {
      showMessage(
        'errors',
        messages.dataset.error,
        missingLabels.map(function (label) {
          return `${label}: ${messages.dataset.emptyFields}`;
        })
      );
      clearApiErrorsAfterDelay();
      return;
    }

    activeSubmitButton = event.submitter;
    setSubmitLoading(true);
    console.log('Enviando formulario...');

    /* =================================
       OBTENER DATOS DEL FORMULARIO
    ================================= */

    const formData = new FormData(form);
    const dataToSend = {};

    formData.forEach(function (value, key) {
      dataToSend[key] = value;
    });

    /*
     * Acción de la API
     */
    dataToSend.action = 'customer_data_v2';

    console.log('Datos enviados a la API:');
    console.log(dataToSend);

    try {

      /* =================================
         FETCH
      ================================= */
      const response = await fetch(
        'https://sign24h.com/a/validate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSend)
        }
      );
      console.log('HTTP Status:', response.status);
      /* =================================
         RESPUESTA
      ================================= */

      const responseText = await response.text();
      console.log('Respuesta API:', responseText);
      let data;

      try {
        data = JSON.parse(responseText);
      } catch (jsonError) {
        console.error(
          'La API no devolvió JSON válido:',
          responseText
        );

        throw new Error(
          'La respuesta del servidor no es un JSON válido.'
        );

      }
      /* =================================
         RESULTADO
      ================================= */

      const professionalStatus = data.is_profesional ?? (data.data && data.data.is_profesional);

      if (response.ok && Number(professionalStatus) === 1) {

        console.log(
          'Formulario enviado correctamente:',
          data
        );

        showResultAndReload();
        showProfessionalMessage('success', messages.dataset.professionalSuccess);

      } else if (response.ok && Number(professionalStatus) === 0) {

        showResultAndReload();
        showProfessionalMessage(
          'error',
          messages.dataset.professionalError,
          messages.dataset.professionalErrorDetail
        );

      } else if (response.ok && data.status === 'success') {

        console.log(
          'Formulario enviado correctamente:',
          data
        );

        showResultAndReload();
        showMessage('success', messages.dataset.success, []);

      } else {

        console.error(
          'La API devolvió un error:',
          data
        );

        showMessage('errors', messages.dataset.error, getApiErrors(data));
        clearApiErrorsAfterDelay();
        setSubmitLoading(false);
      }

    } catch (error) {

      console.error(
        'Error procesando el formulario:',
        error
      );

      showMessage('errors', messages.dataset.error, []);
      clearApiErrorsAfterDelay();
      setSubmitLoading(false);
    }
  });

});


/* ===================================
   LOAD STATES
=================================== */

function loadStates2() {

  const provincia = document.getElementById('reg-provincia');
  const country = document.getElementById('reg-contry');

  if (!provincia || !country) {
    return;
  }


  /* =================================
     LIMPIAR PROVINCIAS
  ================================= */

  provincia.innerHTML = '';

  /* =================================
     PAÍS SELECCIONADO
  ================================= */

  const selectedOption =
    country.options[country.selectedIndex];

  if (!selectedOption) {
    return;
  }

  const currVal = selectedOption.value;
  const currText = selectedOption.textContent;


  /* =================================
     DATA PROVINCES
  ================================= */

  const currStatesText =
    selectedOption.getAttribute('data-provinces');


  try {

    /*
     * Si no existe data-provinces
     */

    if (!currStatesText) {

      const option =
        document.createElement('option');

      option.value = currVal;
      option.textContent = currText;

      provincia.appendChild(option);

      return;
    }


    /* =================================
       PARSEAR JSON
    ================================= */

    const currStates =
      JSON.parse(currStatesText);


    /* =================================
       PROVINCIAS
    ================================= */

    if (
      Array.isArray(currStates) &&
      currStates.length > 0
    ) {

      currStates.forEach(function (element) {

        if (!Array.isArray(element)) {
          return;
        }


        const option =
          document.createElement('option');

        option.value = element[0];
        option.textContent = element[1];

        provincia.appendChild(option);

      });

    } else {

      /*
       * Si no tiene provincias,
       * mostrar el país como opción
       */

      const option =
        document.createElement('option');

      option.value = currVal;
      option.textContent = currText;

      provincia.appendChild(option);

    }

  } catch (error) {

    console.error(
      'Error parseando data-provinces:',
      error
    );


    /* =================================
       FALLBACK
    ================================= */

    const option =
      document.createElement('option');

    option.value = currVal;
    option.textContent = currText;

    provincia.appendChild(option);

  }

}
